{
  "info": "Informații",
  "negative": "Eroare",
  "positive": "Succes"
}
